import { render, staticRenderFns } from "./HtmlEditor.vue?vue&type=template&id=0f90b39e&scoped=true&"
import script from "./HtmlEditor.vue?vue&type=script&lang=js&"
export * from "./HtmlEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f90b39e",
  null
  
)

export default component.exports